module.exports = __webpack_public_path__ + "img/JMMP_Website_Projects_Typefaces_03_JM-10.64fe4bfd.svg";